import MuiInputAdornment from '@material-ui/core/InputAdornment';
import React, { FC } from 'react';

import { Loader } from 'src/Loader';

import Checkmark from '../../images/checkmark-greenV2.svg';
import Error from '../../images/reject.svg';
import useStyles from '../styles';

interface GetIconProps {
  error?: boolean;
  isLoading?: boolean;
  valid?: boolean;
  /**
   * Names the valid checkmark, which is otherwise the only sign of that state.
   * Pass a translated string; without one the checkmark is decorative.
   */
  validLabel?: string;
}

const getIcon: FC<GetIconProps> = props => {
  if (props.isLoading) return <Loader block />;
  // Decorative: the input's error text names the error.
  if (props.error) return <img alt="" src={Error} />;
  if (props.valid) return <img alt={props.validLabel ?? ''} src={Checkmark} />;
  return null;
};

export interface InputAdornmentProps extends GetIconProps {
  position: `start` | 'end';
}

export const InputAdornment: FC<InputAdornmentProps> = ({ position, ...props }) => {
  const classes = useStyles({});

  const Icon = getIcon(props);

  if (Icon) {
    return (
      <MuiInputAdornment classes={{ root: classes.inputAdornment }} position={position}>
        {Icon}
      </MuiInputAdornment>
    );
  }
  return null;
};
